/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EligibilityRoutingReason = {
    MedicareInovalonOnly: 'medicare_inovalon_only',
    MedicaidInovalonOnly: 'medicaid_inovalon_only',
    StediSelectedSupported: 'stedi_selected_supported',
    StediEnrollmentLive: 'stedi_enrollment_live',
    MedicareMbiLookup: 'medicare_mbi_lookup',
    MedicareSsnMbiLookup: 'medicare_ssn_mbi_lookup',
    InovalonSelected: 'inovalon_selected',
} as const;
export type EligibilityRoutingReason = typeof EligibilityRoutingReason[keyof typeof EligibilityRoutingReason];


export function instanceOfEligibilityRoutingReason(value: any): boolean {
    for (const key in EligibilityRoutingReason) {
        if (Object.prototype.hasOwnProperty.call(EligibilityRoutingReason, key)) {
            if (EligibilityRoutingReason[key as keyof typeof EligibilityRoutingReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EligibilityRoutingReasonFromJSON(json: any): EligibilityRoutingReason {
    return EligibilityRoutingReasonFromJSONTyped(json, false);
}

export function EligibilityRoutingReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityRoutingReason {
    return json as EligibilityRoutingReason;
}

export function EligibilityRoutingReasonToJSON(value?: EligibilityRoutingReason | null): any {
    return value as any;
}

export function EligibilityRoutingReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): EligibilityRoutingReason {
    return value as EligibilityRoutingReason;
}

